import WorkQDrawer from "./WorkQDrawer"
import { useSelector } from "react-redux"

export default function WorkQDrawerWrapper({ data, slug, workq }) {
    const activeDrawer = useSelector((state) => state.workqueue.activeDrawer)
    const rowCaseId = data?.case?.id
    const showDrawer =
        activeDrawer != null &&
        rowCaseId != null &&
        Number(rowCaseId) === Number(activeDrawer)

    return (
        <>
            {showDrawer && (
                <tr>
                    <td colSpan="100%" style={{ padding: 0 }}>
                        <WorkQDrawer data={data} slug={slug} workq={workq} />
                    </td>
                </tr>
            )}
        </>
    )
}